import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import GS from '../../grafsync/grafsync';
import AreYouSure from '../AreYouSure';
import Errored from '../Errored';
import Loading from '../Loading';
import { makeCancelable } from '../utils/utils';
import UserDetail from './UserDetail';
import { globalStyles as styles } from '../../core/style/gstheme';

const CHECK_TIME = 2000;

class UserContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      user: null,
      hadHadTrial: null,
      checking: false,
      areYouSure: false
    };
    this.cancellable = null;
  }

  checkIfSure = () => this.setState({ areYouSure: true });

  onSure = () => {
    this.setState({ areYouSure: false });
    this.props.onBlockUser(this.props.user);
  };

  onUnblockUser = () => this.props.onUnblockUser(this.props.user);

  onNotSure = () => this.setState({ areYouSure: false });

  componentDidMount() {
    this.getUserInformation(this.props.user);
  }

  getUserInformation(userIRI) {
    this.setState(
      { isLoading: true },
      async () => {
        try {
          const user = await this.doGetUserDetail(userIRI).promise;
          const subscriptions = await this.doGetSubscriptions(userIRI).promise;
          const invitations = await this.doGetInvitations(userIRI).promise;
          if (this.cancellable && this.cancellable.isCancelled()) return;
          this.setState({
            user,
            hasHadTrial: user.hasHadTrial,
            subscriptions,
            invitations,
            isLoading: false
          });
        }
        catch (e) {
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
        }
      });
  }

  doGetUserDetail(userIRI) {
    this.cancellable = makeCancelable(GS.getUserAsAdmin(userIRI));
    return this.cancellable;
  }

  deleteAccount = async (userIRI) => {
    await GS.deleteAccount(userIRI);
    this.setState({ checking: true }, () => this.checkDeletionStatus(userIRI));
  };

  checkDeletionStatus = async (userIRI) => {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
    try {
      const user = await this.doGetUserDetail(userIRI).promise;
      if (this.cancellable && this.cancellable.isCancelled()) return;
      if (user.pendingDeletion) {
        this.setState({ user, checking: false });
      }
      else {
        this.hcTimeout = setTimeout(() => { this.checkDeletionStatus(userIRI); }, CHECK_TIME);
      }
    }
    catch (e) {
      if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ checking: false, isErrored: e });
    }
  };

  changeTrial = (hasHadTrial) => {
    GS.updateUserAsAdmin(this.props.user, hasHadTrial);
    this.setState({ hasHadTrial });
  };

  doGetSubscriptions(userIRI) {
    this.cancellable = makeCancelable(GS.getUserSubscriptionsAsAdmin(userIRI));
    return this.cancellable;
  }

  doGetInvitations(userIRI) {
    this.cancellable = makeCancelable(GS.getUserInvitationsAsAdmin(userIRI));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
  }

  addSubscription = async (data) => {
    try {
      data.transferUser = this.props.user;
      return this.doCreateSubscription(data).promise;
    }
    catch (e) {
      if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
    }
  };

  doCreateSubscription(data) {
    this.cancellable = makeCancelable(GS.createSubscription(data.name, data.productID, data.transferUser));
    return this.cancellable;
  }

  render() {

    const { isLoading, isErrored, user, areYouSure, subscriptions, hasHadTrial, invitations, checking } = this.state;
    const { classes, managingUser } = this.props;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoading) return <Loading />;

    const recentBlockStatus = this.props.blockedChanges[user.id] || null;
    const blocked = recentBlockStatus ? recentBlockStatus === "blocked" : user.blocked === true;

    return (
      <div>
        <UserDetail
          changeTrial={this.changeTrial}
          user={user}
          managingUser={managingUser}
          hasHadTrial={hasHadTrial}
          blocked={blocked}
          subscriptions={subscriptions}
          invitations={invitations}
          addSubscription={this.addSubscription}
          unblockUser={this.onUnblockUser}
          deleteAccount={this.deleteAccount}
          blockUser={this.checkIfSure} />
        {areYouSure && <AreYouSure onSure={this.onSure} onNotSure={this.onNotSure} message="Do you really want to block this user?" />}
        {checking && <div>
          <Dialog open={true} aria-labelledby="waiting-dialog-title" >
            <DialogTitle
              disableTypography
              className={classes.mainHeading}
              id="waiting-dialog-title">Processing User Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText className={classes.dialogText}>Please wait.</DialogContentText>
            </DialogContent>
          </Dialog>
        </div>
        }
      </div>
    );
  }
}

UserContainer.propTypes = {
  user: PropTypes.string.isRequired,
  managingUser: PropTypes.object.isRequired,
  classes: PropTypes.object,
  blockedChanges: PropTypes.object,
  onBlockUser: PropTypes.func.isRequired,
  onUnblockUser: PropTypes.func.isRequired
};

export default withStyles(styles)(UserContainer);